
    import { defineComponent } from 'vue'

    export default defineComponent({
        computed: {
            isLogoCentered (): boolean {
                return this.$vuetify.breakpoint.name === 'sm' || this.$vuetify.breakpoint.name === 'md'
            }
        }
    })
